import axios from 'axios'
// import { ElMessage } from 'element-plus' // 如果使用 element-plus
// 或者使用自定义提示组件

// 创建 axios 实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API || '/', // 基础URL
   // 开发环境使用代理，生产环境使用真实地址
  baseURL: process.env.NODE_ENV === 'development' 
    ? '/api'  // 代理前缀
    : 'https://rs.yiigle.com/api',  // 生产环境地址
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 可以在这里添加 token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 根据后端返回的 code 判断请求状态
    if (res.code === 200 || res.code === 0) {
      return res.data || res
    } else {
      // 错误处理
      // ElMessage.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  error => {
    console.error('响应错误:', error)
    
    // HTTP 状态码处理
    if (error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误'
          break
        case 401:
          error.message = '未授权，请重新登录'
          // 可以跳转到登录页
          // router.push('/login')
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          error.message = '请求地址出错'
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器内部错误'
          break
        case 501:
          error.message = '服务未实现'
          break
        case 502:
          error.message = '网关错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网关超时'
          break
        case 505:
          error.message = 'HTTP版本不受支持'
          break
        default:
          error.message = '网络错误'
      }
    } else if (error.message.includes('timeout')) {
      error.message = '请求超时'
    } else if (error.message.includes('Network Error')) {
      error.message = '网络连接错误'
    }
    
    // ElMessage.error(error.message)
    return Promise.reject(error)
  }
)

export default service